module.exports = __webpack_public_path__ + "static/2-6c32787e0e59536d2e765cad7b72dbdf.jpg";